import styled from 'styled-components/macro';

interface Props {
    className?: string;
    children: React.ReactNode;
}

export const TableView = (props: Props) => {
    return <S_TableView className={props.className}>{props.children}</S_TableView>;
};

const S_TableView = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;
